import React from 'react';
import { StyleSheet, View } from 'react-native';
import ExpressiveLgText from 'shared/components/vxl/typography/expressive/ExpressiveLgText';
import theme from 'shared/styles/theme';

const CheckDepositDetailsHeader = ({
  amountValueText,
}: {
  amountValueText: string;
}) => {
  if (amountValueText) {
    return (
      <View style={styles.amountContainer}>
        <ExpressiveLgText numberOfLines={1}>{amountValueText}</ExpressiveLgText>
      </View>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  amountContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    paddingVertical: theme.spacing.m,
  },
});

export default CheckDepositDetailsHeader;
